/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import VdiModel, { REMOTE_DESKTOP_TYPE } from './VdiModel';
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { VDI_CLIENT } from 'apmui/resource/remoteDesktop/VdiClientInfo';

enum SERVERTYPE {
    SESSION_HOST = 0,
    WEB_ACCESS = 1,
}

class RdpModel extends VdiModel {
    static readonly propNames = ['server_type', 'user_defined_dst', ...VdiModel.propNames];

    rdType: REMOTE_DESKTOP_TYPE.RDP;

    clientType?: VDI_CLIENT;
    launchUri?: string;
    serverType: SERVERTYPE;
    userDefinedDst: boolean;

    height?: number;
    width?: number;
    percent?: number;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.launchUri = resource.props.launchUri;
        this.serverType = parseInt(resource.props.server_type, 10);
        this.userDefinedDst = resource.props.user_defined_dst === '1';

        this.height = parseInt(resource.props.height, 10);
        this.width = parseInt(resource.props.width, 10);
        this.percent = parseInt(resource.props.percent, 10);

        this.clientType = VDI_CLIENT.NATIVE;
        if (resource.props.java_client === '1') {
            this.clientType = VDI_CLIENT.JAVA;
        } else if (resource.props.native_client === '0') {
            this.clientType = VDI_CLIENT.ACTIVEX;
        }

        // auto_logon does not make sense for session_host resources.
        if (this.serverType !== SERVERTYPE.WEB_ACCESS) {
            this.autoLogon = false;
        }
    }

    getPropNames() {
        return RdpModel.propNames;
    }
}

export { RdpModel as default, SERVERTYPE };
